/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * LiftAI API
 * LiftAI elevator/lift asset-management REST API.
 * OpenAPI spec version: 1.0.0 (v1)
 */
import type {
  PatchedTaskUpdateRequest,
  TaskCreateRequest,
  TaskDetail,
  TaskEvidenceCreateRequest,
  TaskKnowledgeDrafts,
  TaskLogCreateRequest,
  TaskPerson,
  TaskPublishRequest,
  TaskPublishResult,
  TaskSummary,
  TaskTidyNotes,
  TaskTidyNotesRequest,
  TasksAssigneesListParams,
  TasksListParams
} from '../../model';

import { customFetch } from '../../../liftApiMutator';

export type tasksListResponse200 = {
  data: TaskSummary[]
  status: 200
}

export type tasksListResponseSuccess = (tasksListResponse200) & {
  headers: Headers;
};
;

export type tasksListResponse = (tasksListResponseSuccess)

export const getTasksListUrl = (params?: TasksListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["portfolio","region"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/tasks/?${stringifiedParams}` : `/api/v1/tasks/`
}

export const tasksList = async (params?: TasksListParams, options?: RequestInit): Promise<tasksListResponse> => {

  return customFetch<tasksListResponse>(getTasksListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}


export type tasksCreateResponse201 = {
  data: TaskDetail
  status: 201
}

export type tasksCreateResponseSuccess = (tasksCreateResponse201) & {
  headers: Headers;
};
;

export type tasksCreateResponse = (tasksCreateResponseSuccess)

export const getTasksCreateUrl = () => {




  return `/api/v1/tasks/`
}

export const tasksCreate = async (taskCreateRequest: TaskCreateRequest, options?: RequestInit): Promise<tasksCreateResponse> => {

  return customFetch<tasksCreateResponse>(getTasksCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(taskCreateRequest)
  }
);}


export type tasksRetrieveResponse200 = {
  data: TaskDetail
  status: 200
}

export type tasksRetrieveResponseSuccess = (tasksRetrieveResponse200) & {
  headers: Headers;
};
;

export type tasksRetrieveResponse = (tasksRetrieveResponseSuccess)

export const getTasksRetrieveUrl = (id: string,) => {




  return `/api/v1/tasks/${id}/`
}

export const tasksRetrieve = async (id: string, options?: RequestInit): Promise<tasksRetrieveResponse> => {

  return customFetch<tasksRetrieveResponse>(getTasksRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}


export type tasksPartialUpdateResponse200 = {
  data: TaskDetail
  status: 200
}

export type tasksPartialUpdateResponseSuccess = (tasksPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type tasksPartialUpdateResponse = (tasksPartialUpdateResponseSuccess)

export const getTasksPartialUpdateUrl = (id: string,) => {




  return `/api/v1/tasks/${id}/`
}

export const tasksPartialUpdate = async (id: string,
    patchedTaskUpdateRequest?: PatchedTaskUpdateRequest, options?: RequestInit): Promise<tasksPartialUpdateResponse> => {

  return customFetch<tasksPartialUpdateResponse>(getTasksPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchedTaskUpdateRequest)
  }
);}


export type tasksEvidenceCreateResponse200 = {
  data: TaskDetail
  status: 200
}

export type tasksEvidenceCreateResponseSuccess = (tasksEvidenceCreateResponse200) & {
  headers: Headers;
};
;

export type tasksEvidenceCreateResponse = (tasksEvidenceCreateResponseSuccess)

export const getTasksEvidenceCreateUrl = (id: string,) => {




  return `/api/v1/tasks/${id}/evidence/`
}

export const tasksEvidenceCreate = async (id: string,
    taskEvidenceCreateRequest: TaskEvidenceCreateRequest, options?: RequestInit): Promise<tasksEvidenceCreateResponse> => {

  return customFetch<tasksEvidenceCreateResponse>(getTasksEvidenceCreateUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(taskEvidenceCreateRequest)
  }
);}


export type tasksKnowledgeDraftsCreateResponse200 = {
  data: TaskKnowledgeDrafts
  status: 200
}

export type tasksKnowledgeDraftsCreateResponseSuccess = (tasksKnowledgeDraftsCreateResponse200) & {
  headers: Headers;
};
;

export type tasksKnowledgeDraftsCreateResponse = (tasksKnowledgeDraftsCreateResponseSuccess)

export const getTasksKnowledgeDraftsCreateUrl = (id: string,) => {




  return `/api/v1/tasks/${id}/knowledge-drafts/`
}

export const tasksKnowledgeDraftsCreate = async (id: string, options?: RequestInit): Promise<tasksKnowledgeDraftsCreateResponse> => {

  return customFetch<tasksKnowledgeDraftsCreateResponse>(getTasksKnowledgeDraftsCreateUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}


export type tasksLogsCreateResponse200 = {
  data: TaskDetail
  status: 200
}

export type tasksLogsCreateResponseSuccess = (tasksLogsCreateResponse200) & {
  headers: Headers;
};
;

export type tasksLogsCreateResponse = (tasksLogsCreateResponseSuccess)

export const getTasksLogsCreateUrl = (id: string,) => {




  return `/api/v1/tasks/${id}/logs/`
}

export const tasksLogsCreate = async (id: string,
    taskLogCreateRequest: TaskLogCreateRequest, options?: RequestInit): Promise<tasksLogsCreateResponse> => {

  return customFetch<tasksLogsCreateResponse>(getTasksLogsCreateUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(taskLogCreateRequest)
  }
);}


export type tasksPublishCreateResponse200 = {
  data: TaskPublishResult
  status: 200
}

export type tasksPublishCreateResponseSuccess = (tasksPublishCreateResponse200) & {
  headers: Headers;
};
;

export type tasksPublishCreateResponse = (tasksPublishCreateResponseSuccess)

export const getTasksPublishCreateUrl = (id: string,) => {




  return `/api/v1/tasks/${id}/publish/`
}

export const tasksPublishCreate = async (id: string,
    taskPublishRequest: TaskPublishRequest, options?: RequestInit): Promise<tasksPublishCreateResponse> => {

  return customFetch<tasksPublishCreateResponse>(getTasksPublishCreateUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(taskPublishRequest)
  }
);}


export type tasksSummarizeCreateResponse200 = {
  data: TaskDetail
  status: 200
}

export type tasksSummarizeCreateResponseSuccess = (tasksSummarizeCreateResponse200) & {
  headers: Headers;
};
;

export type tasksSummarizeCreateResponse = (tasksSummarizeCreateResponseSuccess)

export const getTasksSummarizeCreateUrl = (id: string,) => {




  return `/api/v1/tasks/${id}/summarize/`
}

export const tasksSummarizeCreate = async (id: string, options?: RequestInit): Promise<tasksSummarizeCreateResponse> => {

  return customFetch<tasksSummarizeCreateResponse>(getTasksSummarizeCreateUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}


export type tasksAssigneesListResponse200 = {
  data: TaskPerson[]
  status: 200
}

export type tasksAssigneesListResponseSuccess = (tasksAssigneesListResponse200) & {
  headers: Headers;
};
;

export type tasksAssigneesListResponse = (tasksAssigneesListResponseSuccess)

export const getTasksAssigneesListUrl = (params?: TasksAssigneesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/tasks/assignees/?${stringifiedParams}` : `/api/v1/tasks/assignees/`
}

export const tasksAssigneesList = async (params?: TasksAssigneesListParams, options?: RequestInit): Promise<tasksAssigneesListResponse> => {

  return customFetch<tasksAssigneesListResponse>(getTasksAssigneesListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}


export type tasksTidyNotesCreateResponse200 = {
  data: TaskTidyNotes
  status: 200
}

export type tasksTidyNotesCreateResponseSuccess = (tasksTidyNotesCreateResponse200) & {
  headers: Headers;
};
;

export type tasksTidyNotesCreateResponse = (tasksTidyNotesCreateResponseSuccess)

export const getTasksTidyNotesCreateUrl = () => {




  return `/api/v1/tasks/tidy-notes/`
}

export const tasksTidyNotesCreate = async (taskTidyNotesRequest: TaskTidyNotesRequest, options?: RequestInit): Promise<tasksTidyNotesCreateResponse> => {

  return customFetch<tasksTidyNotesCreateResponse>(getTasksTidyNotesCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(taskTidyNotesRequest)
  }
);}


